"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _componentLibrary = require("../../../componentLibrary");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ValidateContinueButton = function ValidateContinueButton(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.fullValidationRun && /*#__PURE__*/_react.default.createElement(_componentLibrary.Alert, {
    header: "There are errors on this page.",
    content: props.message ? props.message : 'You may continue, but these fields will need to be corrected before submitting.',
    type: "error",
    dismissable: false
  }), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Button, {
    onClick: props.validateContinueClick,
    primary: true
  }, "Continue"));
};
var _default = ValidateContinueButton;
exports.default = _default;